export default `
query CompareList($uid: ID!) {
  compareList(uid: $uid) {
    uid
    items {
      uid
      product {
        __typename
        id
        uid
        sku
        name
        stock_status
        thumbnail {
          url
          position
          disabled
          label
        }
        url_key
        url_rewrites {
          url
        }
        price_range {
          maximum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
          minimum_price {
            final_price {
              currency
              value
            }
            regular_price {
              currency
              value
            }
          }
        }
      }
      attributes {
        code
        value
      }
    }
    attributes {
      code
      label
    }
    item_count
  }
}
`;
